import axios from 'axios';
import { API_ENDPOINTS } from '../config';

export interface NormalizedAddress {
  originalAddress: string;
  city: string;
  district: string;
  commune: string;
  newCity?: string;
  newCommune?: string;
}

export interface TrialResponse {
  success: boolean;
  originalAddress: string;
  normalizedAddress: NormalizedAddress;
  remainingAttempts: number;
}

export interface RemainingAttemptsResponse {
  remainingAttempts: number;
  dailyLimit: number;
}

class TrialService {
  async normalizeAddress(address: string): Promise<NormalizedAddress> {
    try {
      const response = await axios.post<TrialResponse>(API_ENDPOINTS.TRIAL.NORMALIZE, {
        address
      });

      return response.data.normalizedAddress;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Có lỗi xảy ra khi chuẩn hóa địa chỉ');
    }
  }

  async getRemainingAttempts(): Promise<RemainingAttemptsResponse> {
    try {
      const response = await axios.get<RemainingAttemptsResponse>(API_ENDPOINTS.TRIAL.REMAINING);

      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Có lỗi xảy ra khi lấy thông tin lượt dùng thử');
    }
  }
}

export const trialService = new TrialService(); 